"use strict";
var accordion_group_component_1 = require('./accordion/accordion-group.component');
exports.AccordionPanelComponent = accordion_group_component_1.AccordionPanelComponent;
var accordion_component_1 = require('./accordion/accordion.component');
exports.AccordionComponent = accordion_component_1.AccordionComponent;
var accordion_module_1 = require('./accordion/accordion.module');
exports.AccordionModule = accordion_module_1.AccordionModule;



//////////////////
// WEBPACK FOOTER
// ./~/ng2-bootstrap/components/accordion.js
// module id = 1062
// module chunks = 0